import { COMPONENT_DEFUALT_FILTERS } from '@/data'
import { create } from 'zustand'

const ComponentState = create<ComponentStateInterface>((set) => {
    const ComponentInitialState: ComponentStateInterface = {
        Components: [],
        Loading: false,
        Error: false,
        Deleting: null,
        Copying: false,
        HasMore: true,
        Filters: COMPONENT_DEFUALT_FILTERS,
        SetState: (payload: ComponentStateInterface) => set((state: ComponentStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return ComponentInitialState
})

export default ComponentState
